import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import ButtonFlat from '@kurtosys/ksys-app-components/dist/components/base/ButtonFlat';

export default InjectedStyledComponent(ButtonFlat, 'app', ['buttonFlat']);